import {Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges} from '@angular/core';
import {CustomValidators, Question} from '../../model/GeneralModels';
import {FormGroup} from '@angular/forms';
import {StaticMethods} from '../../model/GeneralModels';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-input-field',
  template: `
    <div [ngSwitch]="dataType[0]">
      <mat-form-field *ngSwitchCase="'number'" [formGroup]="Group" appearance="legacy" floatLabel="auto">
        <mat-label>{{fieldLabel}}</mat-label>
        <input type="number" matInput max="{{max}}" formControlName="{{fieldName}}"
               (change)="onChangeCallback($event)">
        <!--      <mat-spinner class="spinner-wrapper" matSuffix *ngIf="inProgress"-->
        <!--                   [ngStyle]="{'display': !inProgress? 'none': 'inline-block'}"></mat-spinner>-->
        <button mat-button *ngIf="clearButton"
                [ngStyle]="{'display': Group.controls[fieldName].value === ''? 'none': 'inline-block'}"
                matSuffix mat-icon-button
                (click)="Group.controls[fieldName].setValue('')">
          <mat-icon>close</mat-icon>
        </button>
        <button mat-button matSuffix (click)="buttonClicked($event)"
                [disabled]="!Group.controls[fieldName].value"><span>{{buttonLabel}}</span></button>
        <mat-icon *ngIf="Icon" matSuffix>{{iconClass}}</mat-icon>
        <mat-hint>{{dataType[1] ? (Group.controls[fieldName].value ? (Group.controls[fieldName].value + '').length : 0)
          + '/' + dataType[1] : ''}}</mat-hint>
        <mat-error *ngIf="Group.controls[fieldName].invalid && Group.controls[fieldName].touched">
          {{getErrorMessage()}}
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngSwitchCase="'password'" [formGroup]="Group" appearance="legacy" floatLabel="auto">
        <mat-label>{{fieldLabel}}</mat-label>

        <input type="password" matInput formControlName="{{fieldName}}"
               (change)="onChangeCallback($event)">
        <!--      <mat-spinner class="spinner-wrapper" matSuffix *ngIf="inProgress"-->
        <!--                   [ngStyle]="{'display': !inProgress? 'none': 'inline-block'}"></mat-spinner>-->
        <button mat-button *ngIf="clearButton"
                [ngStyle]="{'display': Group.controls[fieldName].value === ''? 'none': 'inline-block'}"
                matSuffix mat-icon-button
                (click)="Group.controls[fieldName].setValue('')">
          <mat-icon>close</mat-icon>
        </button>
        <button mat-button matSuffix (click)="buttonClicked($event)"
                [disabled]="!Group.controls[fieldName].value"><span>{{buttonLabel}}</span></button>
        <mat-icon *ngIf="Icon" matSuffix>{{iconClass}}</mat-icon>
        <mat-hint>{{dataType[1] ? (Group.controls[fieldName].value ? (Group.controls[fieldName].value + '').length : 0)
          + '/' + dataType[1] : ''}}</mat-hint>
        <mat-error *ngIf="Group.controls[fieldName].invalid && Group.controls[fieldName].touched">
          {{getErrorMessage()}}
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngSwitchCase="'email'" [formGroup]="Group" appearance="legacy" floatLabel="auto">
        <mat-label>{{fieldLabel}}</mat-label>
        <input type="email" matInput formControlName="{{fieldName}}"
               (change)="onChangeCallback($event)">
        <!--      <mat-spinner class="spinner-wrapper" matSuffix *ngIf="inProgress"-->
        <!--                   [ngStyle]="{'display': !inProgress? 'none': 'inline-block'}"></mat-spinner>-->
        <button mat-button *ngIf="clearButton"
                [ngStyle]="{'display': Group.controls[fieldName].value === ''? 'none': 'inline-block'}"
                matSuffix mat-icon-button
                (click)="Group.controls[fieldName].setValue('')">
          <mat-icon>close</mat-icon>
        </button>
        <button mat-button matSuffix (click)="buttonClicked($event)"
                [disabled]="!buttonEnabled && !Group.controls[fieldName].value"><span>{{buttonLabel}}</span></button>
        <mat-icon *ngIf="Icon" matSuffix>{{iconClass}}</mat-icon>
        <mat-hint>{{dataType[1] ? (Group.controls[fieldName].value ? (Group.controls[fieldName].value + '').length : 0)
          + '/' + dataType[1] : ''}}</mat-hint>
        <mat-error *ngIf="Group.controls[fieldName].invalid && Group.controls[fieldName].touched">
          {{getErrorMessage()}}
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngSwitchDefault type="text" [formGroup]="Group" appearance="legacy" floatLabel="auto">
        <mat-label>{{fieldLabel}}</mat-label>
        <input matInput formControlName="{{fieldName}}"
               (change)="onChangeCallback($event)">
        <!--      <mat-spinner class="spinner-wrapper" matSuffix *ngIf="inProgress"-->
        <!--                   [ngStyle]="{'display': !inProgress? 'none': 'inline-block'}"></mat-spinner>-->
        <button mat-button *ngIf="clearButton"
                [ngStyle]="{'display': Group.controls[fieldName].value === ''? 'none': 'inline-block'}"
                matSuffix mat-icon-button
                (click)="Group.controls[fieldName].setValue('')">
          <mat-icon>close</mat-icon>
        </button>
        <button mat-button matSuffix (click)="buttonClicked($event)"
                [disabled]="!Group.controls[fieldName].value"><span>{{buttonLabel}}</span></button>
        <mat-icon *ngIf="Icon" matSuffix>{{iconClass}}</mat-icon>
        <mat-hint>{{dataType[1] ? (Group.controls[fieldName].value ? (Group.controls[fieldName].value + '').length : 0)
          + '/' + dataType[1] : ''}}</mat-hint>
        <mat-error *ngIf="Group.controls[fieldName].invalid && Group.controls[fieldName].touched">
          {{getErrorMessage()}}
        </mat-error>
      </mat-form-field>
    </div>
  `,
  styleUrls: [
    '../../assets/css/light.theme.css'
  ],
  styles: [`
    mat-form-field {
      width: 100%;
      font-weight: 300;
      direction: inherit;
      font-family: iran-sans, "B yekan", sans-serif;

    }

    .mat-form-field {
      font-family: iran-sans, "B yekan", sans-serif;
    }

    .spinner-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `]
})
export class InputFieldComponent implements OnInit, OnChanges {
  @Input() Group?: FormGroup;
  // @Input() AppSettings?: AppSettingsService;
  @Input() fieldName: string;
  @Input() fieldLabel: string;
  @Input() dataType: any[];
  @Input() disabled: boolean;
  @Input() Icon: boolean;
  @Input() iconClass: string;
  @Input() ngModel: any;
  @Input() even: boolean;
  @Input() twoCol: boolean;
  @Input() button: boolean;
  @Input() buttonLabel: string;
  @Output() OnChange = new EventEmitter<File>();
  @Output() OnButtonClicked = new EventEmitter<string>();
  @Input() clearButton: boolean;
  @Input() inProgress: boolean;
  @Input() buttonEnabled: boolean;
  @Input() viewList: any = {};
  @Input() translation: any = {};
  @Input() testAutoFill: boolean;
  @Input() value: any;
  max: number;
  maxLength: number;
  min: number;
  minLength: number;

  constructor() {}

  ngOnInit() {
    if (this.disabled) {
      const inputElements = document.getElementsByTagName('input');
      console.log(inputElements);
      for (let i = 0; i < inputElements.length; i++) {
        inputElements.item(i).disabled = true;
      }
    }
    if (this.Icon) {
      this.iconClass = StaticMethods.getIcon(this.fieldName);
      console.log(this.iconClass);
    }
  }

  buttonClicked($event) {
    this.OnButtonClicked.emit(this.Group.controls[this.fieldName].value);
  }

  onChangeCallback(event) {
    this.viewList[this.fieldName] = event.target.value;
    this.OnChange.emit(event.target.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataType[1]) {
      switch (this.dataType[0]) {
        case 'number':
          this.max = 1;
          const value = parseInt(this.dataType[1], 10);
          for (let i = 0; i < value; i++) {
            this.max *= 10;
          }
          this.max--;
          console.log(this.dataType, this.testAutoFill, this.fieldLabel, this.max);
          break;
        case 'varchar':
          this.maxLength = this.dataType[1];
          break;
        case 'text':
          this.maxLength = this.dataType[1];
          break;
      }
    }
    if (!environment.production && this.testAutoFill) {
      console.log('auto fill', this.fieldLabel);
      switch (this.dataType[0]) {
        case 'email':
          this.Group.controls[this.fieldName].patchValue('ahmad.sandouk.16@gmail.com');
          break;
        case 'number':
          let testNumber ;
          if (this.dataType[1]) {
            for (let i = 1; i <= this.dataType[1]; i++) {
              testNumber *= 10;
              testNumber += i;
            }
          } else {
            testNumber  ="";
          }
          this.Group.controls[this.fieldName].patchValue(testNumber);
          break;
        case 'text':
          this.Group.controls[this.fieldName].patchValue('');
          break;
      }
    }
    if (this.value) {
      this.Group.controls[this.fieldName].patchValue(this.value);
      this.onChangeCallback(this.value);
    }
  }

  getErrorMessage() {
    return CustomValidators.getErrorMessage(this.Group.controls[this.fieldName].errors);
  }
}
